import { router } from './router';
import { RouterProvider } from 'react-router-dom';
import React, { useEffect } from 'react';
import TagManager from 'react-gtm-module';

const tagManagerArgs = {
  gtmId: 'GTM-W7XWNL8D',
};

function App() {
  useEffect(() => {
    TagManager.initialize(tagManagerArgs);
  }, []);

  return <RouterProvider router={router} />;
}

export default App;
